<template>
  <div>
    <highcharts :constructorType="'mapChart'" class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>

</template>

<script>
import IndiaMap from './indiaGeo.geo.json'
export default {
  props: ['data',"isLegend","height","suffix"],
  data() {
    return {
      chartData: '',
      chartOptions: ''
    };
  },
  created() {
    this.chartData = ''
    this.chartData = this.data
    this.init();
  },
  
  watch: {
    data: {
      deep: true,
      handler: function () {
        this.chartData = this.data
        this.init();
      },
    },
  },
  methods: {
    
    init() {
      const dataPoints = this.chartData?.[0]?.data || [];
      const values = dataPoints.map(point => point.value);
      const maxValue = values.length > 0 ? Math.max(...values) : 100;
      const self = this
      this.chartOptions = {
        chart: {
          map: IndiaMap,
          height: this.height?this.height:'400',
          events: {
            click: function () {
              return false;
            },
            load: function () {
              this.update({
                mapNavigation: {
                  enabled: false
                }
              });
            }
          }
        },
        // colors: ['rgba(19,64,117,0.05)'],
        
        title: {
          text: ''
        },
        exporting: {
          enabled: false,
        },
        subtitle: {
          text: ''
        },
        legend: {
          enabled: this.isLegend?true:false,
          title: {
            text: ''
          }
        },
        tooltip: {
          // headerFormat: '',
          formatter() {
            if (this.point) {
              let mytooltip = ''
              mytooltip += '<span style="color:white;  font-weight:400; font-size:14px;  text-transform:capitalize;">';
              mytooltip += this.point.name + ": ";
              mytooltip += '</span>';
              mytooltip += '<span style="color:white; font-weight:400; font-size:14px;">';
              mytooltip += this.point.value == -105 ? 'NA' : this.point.value+self.suffix ;
              mytooltip += '</span>';
              return mytooltip;
            }
          },
          shared: true,
          useHTML: true,
          borderWidth: 0,
          shadow: {
            color: "rgba(0, 0, 0, 0.25)",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 10,
          backgroundColor: "#065559",
          padding: 12,
        },
        credits: {
          enabled: false,
        },
        mapNavigation: {
          enabled: true, 
          enableButtons: true,  
          buttonOptions: {
            verticalAlign: 'top'
          }
        },
        colorAxis: {
          min: 0,
          // max: maxValue,
          stops: [
            [0, '#E0f4f2'],
            [0.25, '#a3d9d3'],
            [0.5, '#16959A'],
            [0.75, '#0F7B8C'],
            [1, '#065559']
          ],
          minColor: '#FFFFFF',
          startOnTick: false,
          endOnTick: false
        },
        series: [{
          name: 'Country',
          dataLabels: {
            enabled: false,
            formatter: function () {
              if (this.point.value != 105 && this.point.value != null) {
                return this.point.name + '(' + this.point.value + '%)';
              }
            },
            style: {
              color: '#000'
            }
          },
          keys: ['hc-key', 'value', 'color'],
          nullColor: 'red',
          allAreas: true,
          data: this.chartData,
        }]
      }
    }
  }
};
</script>
